<div [formGroup]="form" class="form__wrapper" autocomplete="off">
  <!-- Campi nascosti per disabilitare l'autocompletamento del browser -->
  <input
    type="text"
    name="fake-username"
    style="display: none"
    autocomplete="username"
  />
  <input
    type="password"
    name="fake-password"
    style="display: none"
    autocomplete="new-password"
  />

  <div
    class="tip"
    *ngIf="!paeseSpedizione || (paeseSpedizione && paeseSpedizione === 'IT')"
  >
    {{ "generale.seleziona_spedizione" | translate }}
  </div>

  <div class="row">
    <mat-form-field
      appearance="outline"
      [ngClass]="paeseSpedizione && paeseSpedizione === 'WW' ? 'grow' : 'grow'"
    >
      <mat-label>{{
        "registrazione.nome_denominazione" | translate
      }}</mat-label>
      <input
        matInput
        placeholder="{{ 'registrazione.nome_denominazione' | translate }}"
        [formControl]="spDenominazioneFormControl"
        maxlength="35"
        autocomplete="off"
      />
      <mat-hint
        *ngIf="
          spDenominazioneFormControl.value &&
          spDenominazioneFormControl.value.length > 0
        "
      >
        {{
          spDenominazioneFormControl.value
            ? spDenominazioneFormControl.value.length
            : 0
        }}/35
      </mat-hint>
      <mat-error
        *ngIf="
          spDenominazioneFormControl.hasError('required') &&
          (spDenominazioneFormControl.dirty ||
            spDenominazioneFormControl.touched)
        "
      >
        {{ "generale.richiesto" | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      class="grow__less"
      *ngIf="paeseSpedizione && paeseSpedizione === 'WW'"
    >
      <mat-label>{{ "registrazione.country" | translate }}</mat-label>
      <mat-select
        [formControl]="spCountryFormControl"
        (selectionChange)="onCountryChange($event)"
        [attr.autocomplete]="'off'"
      >
        <mat-option *ngFor="let stato of statiSelect2Data" [value]="stato">
          {{ stato.text }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="
          spCountryFormControl.hasError('required') &&
          (spCountryFormControl.dirty || spCountryFormControl.touched)
        "
      >
        {{ "generale.richiesto" | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      [ngClass]="
        paeseSpedizione && paeseSpedizione === 'WW' ? 'grow__until' : 'grow'
      "
    >
      <mat-label>{{ "registrazione.telefono" | translate }}</mat-label>
      <input
        matInput
        placeholder="{{ 'registrazione.telefono' | translate }}"
        [formControl]="spTelefonoFormControl"
        autocomplete="off"
      />
      <span matTextPrefix *ngIf="prefix">
        <small> ({{ prefix }})&nbsp; </small>
      </span>
      <mat-error
        *ngIf="
          spTelefonoFormControl.hasError('required') &&
          (spTelefonoFormControl.dirty || spTelefonoFormControl.touched)
        "
      >
        {{ "generale.richiesto" | translate }}
      </mat-error>
    </mat-form-field>
  </div>

  <div class="row">
    <mat-form-field
      appearance="outline"
      class="grow__half"
      *ngIf="!paeseSpedizione || (paeseSpedizione && paeseSpedizione === 'IT')"
    >
      <mat-label>{{ "registrazione.provincia" | translate }}</mat-label>
      <input
        matInput
        placeholder="{{ 'registrazione.provincia' | translate }}"
        [formControl]="spProvinciaFormControl"
        [matAutocomplete]="autoProvince"
        autocomplete="new-password"
        (change)="changeProvincia($event)"
      />
      <mat-autocomplete
        autoActiveFirstOption
        #autoProvince="matAutocomplete"
        (optionSelected)="changeProvincia($event)"
      >
        <mat-option
          *ngFor="let provincia of filteredProvince | async"
          [value]="provincia.sigla"
        >
          {{ provincia.provincia }}
        </mat-option>
      </mat-autocomplete>
      <mat-hint>
        {{ "registrazione.provincia_hint" | translate }}
      </mat-hint>
      <mat-error
        *ngIf="
          spProvinciaFormControl.hasError('required') &&
          (spProvinciaFormControl.dirty || spProvinciaFormControl.touched)
        "
      >
        {{ "generale.richiesto" | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      class="grow__half"
      *ngIf="paeseSpedizione && paeseSpedizione === 'WW'"
    >
      <mat-label>{{ "registrazione.provincia" | translate }}</mat-label>
      <input
        matInput
        placeholder="{{ 'registrazione.provincia' | translate }}"
        [formControl]="spProvinciaFormControl"
        autocomplete="off"
      />
      <mat-error
        *ngIf="
          spProvinciaFormControl.hasError('required') &&
          (spProvinciaFormControl.dirty || spProvinciaFormControl.touched)
        "
      >
        {{ "generale.richiesto" | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="grow__half">
      <mat-label>{{ "registrazione.citta" | translate }}</mat-label>
      <input
        matInput
        placeholder="{{ 'registrazione.citta' | translate }}"
        [formControl]="spCittaFormControl"
        [matAutocomplete]="autoCity"
        autocomplete="new-password"
        [readonly]="readonly.citta_sp"
      />
      <mat-autocomplete
        autoActiveFirstOption
        #autoCity="matAutocomplete"
        (optionSelected)="changeCitta($event)"
      >
        <mat-option
          *ngFor="let citta of filteredCitta | async"
          [value]="citta.comune"
        >
          {{ citta.comune }}
        </mat-option>
      </mat-autocomplete>
      <mat-error
        *ngIf="
          spCittaFormControl.hasError('required') &&
          (spCittaFormControl.dirty || spCittaFormControl.touched)
        "
      >
        {{ "generale.richiesto" | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="grow__less">
      <mat-label>{{ "registrazione.cap" | translate }}</mat-label>
      <input
        matInput
        placeholder="{{ 'registrazione.cap' | translate }}"
        [formControl]="spCapFormControl"
        [matAutocomplete]="autoCap"
        autocomplete="new-password"
        [readonly]="readonly.cap_sp"
      />
      <mat-autocomplete #autoCap="matAutocomplete" autoActiveFirstOption>
        <mat-option *ngFor="let zip of filteredZip | async" [value]="zip">
          {{ zip }}
        </mat-option>
      </mat-autocomplete>
      <mat-error
        *ngIf="
          spCapFormControl.hasError('required') &&
          (spCapFormControl.dirty || spCapFormControl.touched)
        "
      >
        {{ "generale.richiesto" | translate }}
      </mat-error>
    </mat-form-field>
  </div>

  <div
    class="row"
    [ngClass]="paeseSpedizione && paeseSpedizione === 'WW' ? '' : 'mb-1'"
  >
    <mat-form-field appearance="outline" class="grow__until">
      <mat-label>{{ "registrazione.indirizzo" | translate }}</mat-label>
      <input
        matInput
        placeholder="{{ 'registrazione.indirizzo' | translate }}"
        [formControl]="spIndirizzoFormControl"
        maxlength="40"
        autocomplete="off"
      />
      <mat-hint
        *ngIf="
          spIndirizzoFormControl.value &&
          spIndirizzoFormControl.value.length > 0
        "
      >
        {{
          spIndirizzoFormControl.value
            ? spIndirizzoFormControl.value.length
            : 0
        }}/40
      </mat-hint>
      <mat-error
        *ngIf="
          spIndirizzoFormControl.hasError('required') &&
          (spIndirizzoFormControl.dirty || spIndirizzoFormControl.touched)
        "
      >
        {{ "generale.richiesto" | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="grow__less">
      <mat-label>{{ "registrazione.civico" | translate }}</mat-label>
      <input
        matInput
        placeholder="{{ 'registrazione.civico' | translate }}"
        [formControl]="spHouseNumberFormControl"
        maxlength="4"
        autocomplete="off"
      />
      <mat-hint
        *ngIf="
          spHouseNumberFormControl.value &&
          spHouseNumberFormControl.value.length > 0
        "
      >
        {{
          spHouseNumberFormControl.value
            ? spHouseNumberFormControl.value.length
            : 0
        }}/4
      </mat-hint>
      <mat-error
        *ngIf="
          spHouseNumberFormControl.hasError('required') &&
          (spHouseNumberFormControl.dirty || spHouseNumberFormControl.touched)
        "
      >
        {{ "generale.richiesto" | translate }}
      </mat-error>
    </mat-form-field>
  </div>

  <div class="row mb-1" *ngIf="paeseSpedizione && paeseSpedizione === 'WW'">
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>{{ "registrazione.notespedizione" | translate }}</mat-label>
      <textarea
        matInput
        placeholder="{{ 'registrazione.notespedizione' | translate }}"
        [formControl]="spNoteFormControl"
        autocomplete="off"
      ></textarea>
      <mat-hint>{{ "registrazione.notespedizione_hint" | translate }}</mat-hint>
    </mat-form-field>
  </div>
</div>
